<template>
  <b-modal
    id="add-bank-account"
    ref="add-bank-account"
    hide-footer
    title="افزودن کارت جدید"
    @hidden="$emit('hidden')"
  >
    <ValidationObserver ref="step0" v-slot:="{ handleSubmit }" tag="div">
      <form class="needs-validation" @submit.prevent="handleSubmit(submit)">
        <div class="flex flex-column">
          <div class="col-12">
            <validation-input
              v-model="form.name"
              type="text"
              placeholder="نام کارت"
              rules="required"
              validation-field-name="نام کارت"
              label="نام کارت"
            ></validation-input>
          </div>
          <div class="col-12">
            <validation-input
              v-model="form.ownerName"
              type="text"
              placeholder="نام صاحب کارت"
              rules="required"
              validation-field-name="نام صاحب کارت"
              label="نام صاحب کارت"
            ></validation-input>
          </div>
          <div class="col-12">
            <validation-input
              v-model="form.cardInfo"
              type="text"
              placeholder="شماره 16 رقمی کارت"
              rules="required|numeric|min:16|max:16"
              validation-field-name="شماره کارت"
              label="شماره کارت"
            ></validation-input>
          </div>
          <div class="col-12">
            <validation-input
              v-model="form.iban_number"
              type="text"
              placeholder="شماره 24 رقمی شبا"
              rules="required|numeric|min:24|max:24"
              validation-field-name="شماره شبا"
              label="شماره شبا"
            ></validation-input>
          </div>
          <button
            class="btn btn-success mt-4"
            style="float: left"
            type="submit"
          >
            {{ form.id ? 'ویرایش کارت' : 'افزودن کارت' }}
          </button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  name: 'BankAccountForm',
  props: {
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      form: {
        name: '',
        cardInfo: '',
        ownerName: '',
        iban_number: '',
      },
    }
  },
  methods: {
    submit() {
      const data = JSON.parse(JSON.stringify(this.form))
      if (this.form.id != undefined) {
        this.updateRecord(data)
      } else {
        this.createRecord(data)
      }
    },
    createRecord(data) {
      this.$axios.post('bank-accounts', data).then((res) => {
        this.$store.dispatch('tables/addNewItem', {
          key: 'bankAccounts',
          item: res.data,
        })
        Swal.fire('موفق!', `کارت بانکی با موفقیت ثبت شد`, 'success')
        this.$emit('created')
      })
    },
    updateRecord(data) {
      this.$axios.put(`bank-accounts/${data.id}`, data).then(() => {
        Swal.fire('موفق!', `کارت بانکی با موفقیت به روزرسانی شد`, 'success')
        this.$store.dispatch('tables/updateItem', {
          key: 'bankAccounts',
          item: data,
        })
        this.$emit('updated')
      })
    },
  },
  mounted() {
    this.$refs['add-bank-account'].show()
    if (this.item != null) this.form = JSON.parse(JSON.stringify(this.item))
  },
}
</script>
